import React from 'react'
import './userLogin.scss'

export default class UserLogin extends React.Component {
  render () {
    return (
      <div className="user-login">
        Alex 2020
      </div>
    )
  }
}
